

export const VIDEO_PRODUCT_GROUP = 'video-products';
export const VIDEO_LIFETIME_INSTALLMENT_PLAN_SLUG = 'lifetime-video-installment-plan';
export const VIDEO_LIFETIME_SINGLE_PAYMENT_SLUG = 'premium-video-plan-single-payment';
export const VIDEO_MONTHLY_PAYMENT_SLUG = 'premium-monthly-video-plan';
export const VIDEO_YEARLY_PAYMENT_SLUG = 'premium-yearly-video-plan';
